import httpClient, { requestData } from '../httpClient';

// Tier 2 — derasar admin
export const getDerasarNotificationSettings = (derasarId) =>
  requestData(httpClient.get('/notification-settings/derasar', { params: { derasarId } }));

export const updateDerasarNotificationSetting = (payload) =>
  requestData(httpClient.put('/notification-settings/derasar', payload));

// Tier 3 — user
export const getMyNotificationSettings = (derasarId) =>
  requestData(httpClient.get('/notification-settings/me', { params: { derasarId } }));

export const updateMyNotificationSetting = (payload) =>
  requestData(httpClient.put('/notification-settings/me', payload));

// Tier 1 + usage — super admin
export const getDerasarNotificationChannels = (derasarId) =>
  requestData(httpClient.get(`/super-admin/derasars/${derasarId}/notification-channels`));

export const updateDerasarNotificationChannels = (derasarId, payload) =>
  requestData(httpClient.put(`/super-admin/derasars/${derasarId}/notification-channels`, payload));

export const getNotificationUsage = (params) =>
  requestData(httpClient.get('/super-admin/notification-usage', { params }));
